import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15 0C6.728 0 0 6.731 0 15s6.728 15 15 15 15-6.728 15-15S23.268 0 15 0m1.501 26.893V3.107C22.408 3.848 26.998 8.895 26.998 15S22.408 26.152 16.5 26.893"
    }, null, -1)
  ]))]))
}
export default { render: render }